export const NOVO_TIPO_FORM_ID = "novo-tipo-obra-form";

export const NOVO_TIPO_TITLE = "Adicionar Tipo de Obra";
export const CENTRO_CUSTO_LABEL = "Centro de custo";
export const CENTRO_CUSTO_PLACEHOLDER = "Selecione o centro de custo";
export const CENTRO_CUSTO_INDISPONIVEL_PLACEHOLDER = "Nenhum centro de custo disponível";
/** Ajuda do centro travado (Figma 15597:1823006). */
export const CENTRO_CUSTO_UNICO_AJUDA =
  "Único centro de custo desta Obra com Tipo de Obra disponível.";
export const TIPO_OBRA_LABEL = "Tipo de Obra";
export const TIPO_OBRA_PLACEHOLDER = "Selecione o Tipo de Obra";
export const TIPO_OBRA_ESCOLHA_CENTRO_PLACEHOLDER = "Escolha o centro de custo primeiro";
export const DOMINANTE_LABEL = "Tipo de Obra dominante";
export const DOMINANTE_TOOLTIP = "O dominante define a descrição da parada na Ficha.";
export const MANTER_LABEL = "Manter";
export const TROCAR_LABEL = "Trocar";
/** Cartões da dominância (Figma 15597:1823330 e 15597:1823375). */
export const MANTER_DESCRICAO = "Dominante atual. A descrição da parada na Ficha continua a mesma.";
export const TROCAR_PARA_LABEL = "Trocar para";
export const TROCAR_DESCRICAO = (ordem: string) =>
  `Segue a ordem de dominância: ${ordem}. Exige justificativa.`;

/** Obra sem dominante: o Figma não desenha o estado. */
export const CONFIRMAR_SUGERIDO_LABEL = "Confirmar";
export const CONFIRMAR_SUGERIDO_DESCRICAO =
  "Sugerido pela ordem de dominância, entre os Tipos de Obra do Centro de custo principal.";
export const ESCOLHER_OUTRO_LABEL = "Escolher outro Tipo de Obra";
export const ESCOLHER_OUTRO_DESCRICAO =
  "Outro Tipo de Obra do Centro de custo principal. Exige justificativa.";
export const DOMINANTE_ESCOLHA_LABEL = "Novo Tipo de Obra dominante";
export const DOMINANTE_ESCOLHA_PLACEHOLDER = "Selecione o Tipo de Obra dominante";
export const DOMINANTE_ESCOLHA_OBRIGATORIA = "Selecione o Tipo de Obra dominante.";
/** Valor do seletor para o próprio Tipo que está sendo incluído (ainda sem id na Obra). */
export const NOVO_TIPO_VALOR = "novo-tipo";

export const ADICIONAR_LABEL = "Adicionar Tipo de Obra";
export const SOLICITAR_LABEL = "Solicitar inclusão";
export const CANCELAR_LABEL = "Cancelar";
export const EM_APROVACAO_TAG = "Em aprovação";

export const CARREGANDO_LABEL = "Carregando opções...";
export const SEM_CENTRO_CUSTO_ELEGIVEL =
  "Nenhum centro de custo desta Obra tem Tipo de Obra disponível para inclusão. Ajuste a estrutura da Obra ou a habilitação dos coletores em Financeiro › Configurações e tente de novo.";
export const SEM_TIPO_ELEGIVEL = "Não há Tipo de Obra disponível para este Centro de Custo.";

/** Figma 15597:1823006: aviso do FEL-1 em diante. */
export const AVISO_GMUD = (fel: string) =>
  `A Obra está em ${fel}. A inclusão será enviada para aprovação por GMUD e só entra no planejamento depois de aprovada.`;

/** Figma 15597:1823096. */
export const ENVIADO_PARA_APROVACAO = (rotulo: string) =>
  `Solicitação de inclusão do ${rotulo} enviada para aprovação.`;
export const ADICIONADO_MESSAGE = (rotulo: string) => `${rotulo} adicionado à Obra.`;

/** Cabeçalhos do seletor com mais de um Centro de Custo, na ordem de exibição. O nó 15597:1823195 só mostra "SubSea". */
export const GRUPOS_NATUREZA = {
  principal: "Principal",
  "manutencao-operacional": "Manutenção operacional",
  subsea: "SubSea",
  adicional: "Adicional",
} as const;
